import styled from "styled-components";

export const Container = styled.div`
  --paddin-categoria: 50px;
  --font-size-labels: 18px;
  --img-width: 300px;
  --img-heigth: 300px;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  text-align: center;
  height: 90vh;

  .categorias {
    display: flex;
    flex-direction: row;

    .categoria {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: var(--paddin-categoria);

      .img {
        width: var(--img-width);
        height: var(--img-heigth);
        transition: width height 3s;
        &:hover {
          width: 350px;
          height: 350px;
        }
      }

      .labels {
        font-size: var(--font-size-labels);
        font-weight: bold;
        color: #3f3d56;
      }
    }
  }

  @media screen and (max-width: 800px) {
    --paddin-categoria: 30px;
    --img-width: 280px;
    --img-heigth: 280px;
  }

  @media screen and (max-width: 700px) {
    --paddin-categoria: 10px;
  }

  @media screen and (max-width: 600px) {
    --img-width: 250px;
    --img-heigth: 250px;
  }

  @media screen and (max-width: 500px) {
    --paddin-categoria: 20px;
    --img-width: 200px;
    --img-heigth: 200px;
    --font-size-labels: 16px;
  }

  @media screen and (max-width: 550px) {
    --paddin-categoria: 10px;
    --img-width: 150px;
    --img-heigth: 150px;
  }
`;
